import { useHasAccess } from '@energy-stacks/user-access';
import { BrokerFeature } from './brokerFeature';
import { brokerFeatureAccess } from './brokerFeatureAccess';

export const useBrokerFeatureGuard = (feature: BrokerFeature) => {
  return useHasAccess(brokerFeatureAccess, feature);
};
